import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

const noop = () => {
};
export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AgePickerComponent),
    multi: true
};


@Component({
    selector: 'app-age-picker',
    templateUrl: './age-picker.component.html',
    styleUrls: ['./age-picker.component.scss'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
    standalone: false
})
export class AgePickerComponent implements OnInit, ControlValueAccessor {

    public ageInner: number;

    @Input() public yearOnly : boolean = false;

    @Input() private maxAge;

    constructor() { }

    ngOnInit() {

    }

        //Placeholders for the callbacks which are later providesd
    //by the Control Value Accessor
    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    //From ControlValueAccessor interface
    writeValue(value: any) {
        this.ageInner = value
        if (value !== this.value) {
            this.value = value;
        }
    }

    get value(): any {
        return this.ageInner;
    };

    //set accessor including call the onchange callback
    set value(v: any) {
        if (v !== this.ageInner) {
            this.ageInner = v;
            this.onChangeCallback(this.ageInner);
        }
    }

    //From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    public onYearUp(): void {
        this.setAge(this.ageInner + 12);
    }

    public onYearDown(): void {
        this.setAge(this.ageInner - 12);
    }

    public onMonthUp(): void {
        this.setAge(this.ageInner + 1);
    }

    public onMonthDown(): void {
        this.setAge(this.ageInner - 1);
    }

    public menuClicked($event): boolean {
        $event.stopPropagation();
        return false;
    }

    private setAge(newAge: number) {
        if (newAge < 0) {
            newAge = 0;
        }

        if(this.maxAge && newAge > this.maxAge){
            newAge = this.maxAge;
        }

        if(this.ageInner != newAge){
            this.value = newAge;
        }
    }

    public getYears(): number {
        return Math.floor(this.ageInner /12);
    }

    public getMonths() {
        return this.ageInner - (this.getYears() *12);
    }
}
